if($('.id--9').length){

  function mhpridatslevu(){
    $('.cart-table tr').each(function(){
      var findname = $(this).find('a.main-link');
      var finddostupnost = $(this).find('.p-availability').html();
      var findcenazakus = $(this).find('.p-price.p-cell').html();
      var findptotal = $(this).find('.p-total');
      var findpname = $(this).find('.p-name');
      if($(this).find('.dostupnostuceny').length<1){
        $(findpname).append('<span class="dostupnostuceny">'+finddostupnost+'</span>');
      }
      
      if($(this).find('.cenazaks').length<1){
        $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
      }
      
    })
  };
  mhpridatslevu()
document.addEventListener('ShoptetDOMCartContentLoaded', function () {
mhpridatslevu();
  });
}         

    
 
    
  $(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
    if($('html[lang="sk"]').length){
      var zpetDoObchodu = 'Retour à la boutique'
  }
  else{
      var zpetDoObchodu = 'Back to shop'
  }
      $(".advanced-order .extras-wrap").prepend('<div class="extra step-back"><span class="btn inline-block btn-back" href="#" id="mhclose">'+zpetDoObchodu+'</span></div>'),
      
      $('body').on("click","#mhclose",function(){
          $("div#colorbox button#cboxClose").click();
      })
      $.colorbox.resize()
  })

  if($('.id--16, .id--17').length){
    $('[data-testid="recapItemPriceWithVat"], [data-testid="recapItemTotalPriceWithVat"]').each(function() {
      $(this).html(function(){
        return $(this).html().replace("vrátane DPH", "TVA comprise");
      })
    })
    setTimeout(function(){
    $('[data-testid="recapItemPrice"]').each(function() {      
      $(this).html(function(){
        return $(this).html().replace("ZADARMO", "Gratuit");
      })   
   
    })
  }, 150)

    $(document).on("ShoptetBillingMethodUpdated",function(){
      $('[data-testid="recapItemPriceWithVat"], [data-testid="recapItemTotalPriceWithVat"]').each(function() {
        $(this).html(function(){
          return $(this).html().replace("vrátane DPH", "TVA comprise");
        })
      })
      setTimeout(function(){
      $('[data-testid="recapItemPrice"]').each(function() {      
        $(this).html(function(){
          return $(this).html().replace("ZADARMO", "Gratuit");
        })   
     
      })
    }, 150)
       
      
    })
    
  }

  if($('.id--17').length){
    $('select#billCountryId option').each(function() {
   
      $(this).html(function(){
        return $(this).html().replace("Francúzsko", "France");
      })

    
    })  
  
  
  shoptet.scripts.setCustomCallback('shoptet.phoneInput.hideCountriesSelect', function(args) {
    $('.validator-msg').each(function() {
   
      $(this).html(function(){
        return $(this).html().replace("DIČ sa nepodarilo overiť, aj napriek tomu môžete objednávku dokončiť", "Le NIF n'a pas pu être vérifié, vous pouvez quand même terminer la commande.");
      })

    
    })  
  });
  shoptet.scripts.setCustomCallback('shoptet.validator.getExistingMessage', function(args) {
    $('.validator-msg').each(function() {
 
      $(this).html(function(){
        return $(this).html().replace("Overujeme", "Vérifié");
      });


    
    })  
  });
  shoptet.scripts.setCustomCallback('shoptet.validator.getExistingMessage', function(args) {
    $('.validator-msg').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Overené", "Vérifié par");
      });

    
    })  
  });
}